<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px;">
      <div class="card card-sm">
        <div class="card-header" style="background-color: #DBECDB;">
          <h5 class="card-title">Gestión de Tipos de Tramites</h5>
          <div class="row mb-3">
            <div class="col-md-10">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Unidad: </label>
                  <select 
                    v-model="filters.id_unidad" 
                    class="form-select" 
                    @change="handleSearch"
                  >
                    <option value="">Todas las unidades</option>
                    <option 
                      v-for="unidad in unidades" 
                      :key="unidad.id" 
                      :value="unidad.id"
                    >
                      {{ unidad.nombre_unidad }} ({{ unidad.codigo }})
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-8">
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group mb-1">
                    <label class="form-label">Tramite: </label>
                    <input
                      type="text"
                      v-model="filters.tipoSearch"
                      class="form-control"
                      placeholder="Buscar por Tipo de Tramite"
                      @input="searchByTipo"
                      @change="handleSearch"
                      :readonly="filters.id_unidad == ''"
                    />
                    
                    <button 
                      class="btn btn-outline-secondary" 
                      type="button" 
                      @click="handleSearch"
                    >
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                  <!-- Resultados de la búsqueda tipo tramite -->
                  <div v-if="searchResultsTipo.length > 0" class="search-results">
                    <div 
                      v-for="tipoTramite in searchResultsTipo" 
                      :key="tipoTramite.id"
                      class="search-result-item"
                      :class="{ 'selected': form.id_tipo_tramite === tipoTramite.id }"
                      @click="selectTipotramite(tipoTramite)"
                    >
                      {{ tipoTramite.tipo }} 
                      ( {{ tipoTramite.tipo_etapa === 1 ? 'Común' : tipoTramite.tipo_etapa === 2 ? 'Legal' : tipoTramite.tipo_etapa === 3 ? 'Firma' : tipoTramite.tipo_etapa === 4 ? 'Valores' : tipoTramite.tipo_etapa === 5 ? 'MinEdu' : 'desconocido' }} )
                    </div>
                  </div>

                  <!-- Mostrar tipo tramite seleccionada -->
                  <div v-if="form.id_tipo_tramite && selectedTipotramite" class="selected-persona">
                    <strong>Seleccionado:</strong> 
                    {{ selectedTipotramite.tipo }} (Tipo: {{ selectedTipotramite.tipo_etapa }})
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <BButton
                v-if="hasPermission('tipotramite_create')"
                @click="showModal(null)"
                variant="primary"
                class="btn-round btn-sm me-2"
              >
                <i class="fa fa-plus me-1"></i> Nuevo
              </BButton>
              <BButton
                v-if="hasPermission('tipotramite_create')"
                variant="danger"
                class="btn-round btn-sm"
                @click="generatePDF"
              >
                <i class="fa fa-file-pdf me-1"></i> PDF
              </BButton>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>
          
          <div v-else>
            <div class="table-responsive">
              <table class="table table-sm table-striped table-hover table-bordered" style="font-size: 0.8em;">
                <thead class="text-primary">
                  <tr style="line-height: 0.6rem; font-size: 0.8em;">
                    <th>Seccion</th>
                    <th>codigo</th>
                    <th>Nombre Tramite</th>
                    <th>DDE</th>
                    <th>M.E.</th>
                    <th>Val.</th>
                    <th>Total</th>
                    <th>Tiempo</th>
                    <th>Tipo</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tipotramite in tipotramites" :key="tipotramite.id">
                    <td>{{ tipotramite.codigo_area }} - {{ tipotramite.nombre_area }}</td>
                    <td>{{ tipotramite.codigo }}</td>
                    <td>{{ tipotramite.tipo }}</td>
                    <td>{{ tipotramite.costo }}</td>
                    <td>{{ tipotramite.costo_minedu }}</td>
                    <td>{{ tipotramite.costo_valorado }}</td>
                    <td>{{ tipotramite.total }}</td>
                    <td>{{ tipotramite.tiempo }} {{ tipotramite.unidad_tiempo }}</td>
                    <td><span v-if="tipotramite.tipo_etapa === 1">Común</span>
                        <span v-else-if="tipotramite.tipo_etapa === 2">Legal</span>
                        <span v-else-if="tipotramite.tipo_etapa === 3">FirmaDDE</span>
                        <span v-else-if="tipotramite.tipo_etapa === 4">Valores</span>
                        <span v-else-if="tipotramite.tipo_etapa === 5">Minedu</span>
                        <span v-else>Desconocido</span>
                    </td>
                    <td>
                      <BBadge :variant="tipotramite.estado === 'Activo' ? 'success' : 'danger'">
                        {{ tipotramite.estado }}
                      </BBadge>
                    </td>
                    <td>
                      <div class="btn-group">
                        <BButton
                          variant="danger"
                          class="btn-round btn-sm"
                          @click="generateDetallePDF(tipotramite.id)"
                        >
                          <i class="fa fa-file-pdf me-1"></i>
                        </BButton>
                        <router-link 
                          :to="`/tipotramite/detail/${tipotramite.id}`" 
                          class="btn btn-sm btn-success"
                        >
                          <i class="fa fa-folder-open"></i>
                        </router-link>
                        <BButton
                          v-if="hasPermission('tipotramite_update')"
                          @click="showModal(tipotramite)"
                          variant="warning"
                          size="sm"
                          class="me-1"
                        >
                          <i class="fa fa-edit"></i>
                        </BButton>
                        <BButton
                          v-if="hasPermission('tipotramite_delete')"
                          @click="confirmDelete(tipotramite)"
                          variant="danger"
                          size="sm"
                        >
                          <i class="fa fa-trash"></i>
                        </BButton>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- Paginación -->
            <div class="row mt-3" v-if="pagination.total > 0">
              <div class="col-md-12">
                <BPagination
                  v-model="pagination.current_page"
                  :total-rows="pagination.total"
                  :per-page="pagination.per_page"
                  @input="handlePageChange"
                  align="center"
                ></BPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para crear/editar -->
    <BModal
      v-model="modalVisible"
      :title="modalTitle"
      size="lg"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="handleSubmit">
        <div class="row mt-3">
          <div class="col-md-3">
            <div class="form-group">
              <label class="form-label">Codigo</label>
              <input
                type="text"
                v-model="form.codigo"
                class="form-control"
                :class="{ 'is-invalid': errors.codigo }"
                required
              />
              <div class="invalid-feedback" v-if="errors.codigo">
                {{ errors.codigo[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-9">
            <div class="form-group">
              <label class="form-label">Descripcion del Tramite</label>
              <input
                type="text"
                v-model="form.tipo"
                class="form-control"
                :class="{ 'is-invalid': errors.tipo }"
                required
              />
              <div class="invalid-feedback" v-if="errors.tipo">
                {{ errors.tipo[0] }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Costo CTA. DDE-BENI Nº 1000006072958</label>
              <input
                type="text"
                v-model="form.costo"
                class="form-control"
                :class="{ 'is-invalid': errors.costo }"
                required
              />
              <div class="invalid-feedback" v-if="errors.costo">
                {{ errors.costo[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Costo CTA. MINEDU Nº 1000004669343</label>
              <input
                type="number"
                v-model="form.costo_minedu"
                class="form-control"
                :class="{ 'is-invalid': errors.costo_minedu }"
                required
              />
              <div class="invalid-feedback" v-if="errors.costo_minedu">
                {{ errors.costo_minedu[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Unidad Organizacional</label>
              <select
                v-model="form.id_unidad"
                class="form-select" 
                @change="(e) => { console.log('Cambió unidad:', e.target.value); fetchAreas() }"
                :class="{ 'is-invalid': errors.id_unidad }"
                :disabled="loadingUnidades"
              >
                <option value="">Seleccione una unidad</option>
                <option 
                  v-for="unidad in unidades" 
                  :key="unidad.id" 
                  :value="unidad.id"
                >
                  {{ unidad.codigo }} - {{ unidad.nombre_unidad }}
                </option>
              </select>
                    
              <div v-if="errors.id_unidad" class="invalid-feedback">
                {{ errors.id_unidad[0] }}
              </div>
              <div v-if="loadingUnidades" class="text-muted small">
                Cargando unidades...
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Seccion Funcional</label>
              <select 
                class="form-select" 
                v-model="form.id_area" 
                :class="{ 'is-invalid': errors.id_area }"
                :disabled="loadingAreas || !form.id_unidad"
              >
                <option value="">Seleccione una seccion</option>
                <option 
                  v-for="area in areas" 
                  :key="area.id" 
                  :value="area.id"
                >
                  {{ area.codigo }} - {{ area.nombre_area }}
                </option>
              </select>
                    
              <div v-if="errors.id_area" class="invalid-feedback">
                {{ errors.id_area[0] }}
              </div>
              <div v-if="loadingAreas" class="text-muted small">
                Cargando secciones...
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-3">
            <div class="form-group">
              <label class="form-label">Tiempo</label>          
              <input
                type="number"
                v-model="form.tiempo"
                class="form-control"
                :class="{ 'is-invalid': errors.tiempo }"
                required
              />
              <div class="invalid-feedback" v-if="errors.tiempo">
                {{ errors.tiempo[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="form-label">.</label>          
              <select
                v-model="form.unidad_tiempo"
                class="form-select"
                :class="{ 'is-invalid': errors.unidad_tiempo }"
                required
              >
	              <option value="Horas" selected>Horas</option>
	              <option value="Dias">Dias</option>
	              <option value="Semanas">Semanas</option>
              </select>
              <div class="invalid-feedback" v-if="errors.unidad_tiempo">
                {{ errors.unidad_tiempo[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="form-label">Estado</label>
              <select
                v-model="form.estado"
                class="form-select"
                :class="{ 'is-invalid': errors.estado }"
                required
              >
                <option value="Activo">Activo</option>
                <option value="Inactivo">Inactivo</option>
              </select>
              <div class="invalid-feedback" v-if="errors.estado">
                {{ errors.estado[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="form-label">Tipo</label>
              <select
                v-model="form.tipo_etapa"
                class="form-select"
                :class="{ 'is-invalid': errors.tipo_etapa }"
                required
              >
                <option value="1">Tramite Comun</option>
                <option value="2">Juridico Legal</option>
                <option value="3">Firma Direccion</option>
                <option value="4">Venta Valores</option>
                <option value="5">Ministerio Educacion</option>
              </select>
              <div class="invalid-feedback" v-if="errors.tipo_etapa">
                {{ errors.tipo_etapa[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="modalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingForm"
          >
            <span v-if="loadingForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isEditing ? 'Actualizar' : 'Guardar' }}
          </BButton>
        </div>
      </form>
    </BModal>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { useAuthStore } from '../../stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton, BBadge, BPagination } from 'bootstrap-vue-3';

interface Tipotramite {
  id: number;
  tipo: tipo;
  costo: string;
  costo_minedu: string;
  id_unidad: number;
  id_area: number;
  tiempo: number;
  unidad_tiempo: string;
  tipo_etapa: number;
  estado: string;
}

interface FormData {
  id: number | null;
  tipo: tipo;
  costo: string;
  costo_minedu: string;
  id_unidad: number;
  id_area: number;
  tiempo: number;
  unidad_tiempo: string;
  tipo_etapa: number;
  estado: string;
}

interface Filters {
  id_unidad: string;
}

interface Pagination {
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
}

export default {
  components: {
    BModal,
    BButton,
    BBadge,
    BPagination
  },
  setup() {
    const tipotramites = ref<Tipotramite[]>([]);
    const loading = ref(true);
    const unidades = ref<Unidad[]>([]);
    const loadingUnidades = ref(true);
    const areas = ref<Area[]>([]);
    const loadingAreas = ref(true);
    const authStore = useAuthStore();
    const filters = ref<Filters>({
      id_unidad: ''
    });
    
    // Variables para el modal
    const modalVisible = ref(false);
    const isEditing = ref(false);
    const loadingForm = ref(false);
    const errors = ref<Record<string, string[]>>({});

    const tipoSearch = ref('');
    const searchResultsTipo = ref<Persona[]>([]);
    const selectedTipotramite = ref<Persona | null>(null);
    const searchingTipo = ref(false);

    const form = ref<FormData>({
      id: null,
      tipo: '',
      costo: '0',
      costo_minedu: '0',
      id_unidad: '',
      id_area: '',
      tiempo: '0',
      unidad_tiempo: 'Horas',
      tipo_etapa: '1',
      estado: 'Activo'
    });

    // Paginación
    const pagination = ref<Pagination>({
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1
    });

    const modalTitle = computed(() => {
      return isEditing.value ? 'Editar Tipo Tramite' : 'Nuevo Tipo Tramite';
    });

    const showModal = (tipotramite: Tipotramite | null) => {
      errors.value = {};
      if (tipotramite) {
        // Edición
        isEditing.value = true;
        form.value = {
          id: tipotramite.id,
          codigo: tipotramite.codigo,
          tipo: tipotramite.tipo,
          costo: tipotramite.costo,
          costo_minedu: tipotramite.costo_minedu,
          id_unidad: tipotramite.id_unidad,
          id_area: tipotramite.id_area,
          tiempo: tipotramite.tiempo,
          unidad_tiempo: tipotramite.unidad_tiempo,
          tipo_etapa: tipotramite.tipo_etapa,
          estado: tipotramite.estado
        };
        if (tipotramite.id_unidad) {
          fetchAreas();
        }
      } else {
        // Nuevo
        isEditing.value = false;
        form.value = {
          id: null,
          tipo:'',
          costo: '0',
          costo_minedu: '0',
          id_unidad: '',
          id_area: '',
          tiempo: '0',
          unidad_tiempo: 'Horas',
          tipo_etapa: '1',
          estado: 'Activo'
        };
      }
      modalVisible.value = true;
    };

    const handleSubmit = async () => {
      loadingForm.value = true;
      errors.value = {};
      
      try {
        let response;
        
        if (isEditing.value && form.value.id) {
          response = await axios.post(`/tipotramite/update/${form.value.id}`, form.value);
        } else {
          response = await axios.post('/tipotramite/save', form.value);
        }
        
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: response.data.message
        });
        
        modalVisible.value = false;
        fetchTipotramite();
      } catch (error: any) {
        if (error.response && error.response.status === 422) {
          errors.value = error.response.data.errors;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Ocurrió un error al procesar la solicitud'
          });
        }
      } finally {
        loadingForm.value = false;
      }
    };

    const fetchUnidades = async () => {
      try {
        const response = await axios.get('/unidad/select');
        unidades.value = response.data.unidades;
      } catch (error) {
        console.error('Error al cargar unidades:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar las unidades organizacionales'
        });
      } finally {
        loadingUnidades.value = false;
      }
    };

    const fetchAreas = async () => {
      console.log('Iniciando fetchAreas, id_unidad:', form.value.id_unidad);
      if (!form.value.id_unidad) {
        areas.value = []; // Limpiar áreas si no hay unidad seleccionada
        form.value.id_area = ''; // Resetear el área seleccionada
        return;
      }

      loadingAreas.value = true;
      try {
        const response = await axios.get('/area/select', {
          params: { id_unidad: form.value.id_unidad }
        });
        areas.value = response.data.areas || [];
      } catch (error) {
        console.error('Error al cargar secciones:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar las secciones funcionales'
        });
      } finally {
        loadingAreas.value = false;
      }
    };

    const fetchTipotramite = async () => {
      loading.value = true;
      try {
        const params: Record<string, any> = {
          page: pagination.value.current_page,
          per_page: pagination.value.per_page
        };
        
        if (filters.value.id_unidad) {
          params.id_unidad = filters.value.id_unidad;
          params.tipoSearch = filters.value.tipoSearch;
        }
        
        const response = await axios.get('/tipotramite/list', { params });
        tipotramites.value = response.data.tipotramites.data || response.data.tipotramites;
        
        // Actualizar paginación si la API la soporta
        if (response.data.tipotramites.meta) {
          pagination.value = {
            current_page: response.data.tipotramites.meta.current_page,
            per_page: response.data.tipotramites.meta.per_page,
            total: response.data.tipotramites.meta.total,
            last_page: response.data.tipotramites.meta.last_page
          };
        }
        
      } catch (error) {
        console.error('Error al cargar tipotramites:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los tipotramites'
        });
      } finally {
        loading.value = false;
      }
    };

    const handleSearch = () => {
      pagination.value.current_page = 1;
      fetchTipotramite();
    };

    const handlePageChange = (page: number) => {
      pagination.value.current_page = page;
      fetchTipotramite();
    };
    
    const confirmDelete = (tipotramite: Tipotramite) => {
      Swal.fire({
        title: '¿Está seguro?',
        text: `¿Desea eliminar la sección ${tipotramite.descripcion}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          deleteTipotramite(tipotramite.id);
        }
      });
    };
    
    const deleteTipotramite = async (id: number) => {
      try {
        await axios.get(`/tipotramite/delete/${id}`);
        Swal.fire({
          icon: 'success',
          title: 'Sección eliminada',
          text: 'La sección ha sido eliminada correctamente'
        });
        await fetchTipotramite();
      } catch (error: any) {
        console.error('Error al eliminar sección:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo eliminar la sección'
        });
      }
    };

    const generatePDF = () => {
      // Lógica para generar PDF
      const params = filters.value.id_unidad ? { id_unidad: filters.value.id_unidad } : {};
      
      axios.get('/tipotramite/reporte', {
        params,
        responseType: 'blob', // Esto es crucial para manejar PDFs
        headers: {
          'Accept': 'application/pdf' // Especificamos que esperamos un PDF
        }
      }).then(response => {
        // Crear el blob correctamente
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        // Crear enlace y descargar
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `reporte-valorados.pdf`);
        document.body.appendChild(link);
        link.click();
        
        // Limpiar después de la descarga
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };
    
    const generateDetallePDF = (id: number) => {
      axios.get(`/tipotramite/show/${id}/pdf/`, {
        responseType: 'blob', // Esto es crucial para manejar PDFs
        headers: {
          'Accept': 'application/pdf' // Especificamos que esperamos un PDF
        }
      }).then(response => {
        // Crear el blob correctamente
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        // Crear enlace y descargar
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `tipotramite_${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        
        // Limpiar después de la descarga
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };
    const searchByTipo = async () => {
      console.log(filters.value.tipoSearch);
      if (!filters.value.tipoSearch.trim()) {
        searchResultsTipo.value = [];
        return;
      }

      searchingTipo.value = true;
      try {
        const response = await axios.get('/tipotramite/search', {
          params: { 
            tipo: filters.value.tipoSearch,
            unidad: filters.value.id_unidad
          }
        });
        searchResultsTipo.value = response.data.tipotramites || [];
      } catch (error) {
        console.error('Error al buscar tipo de tramites:', error);
        searchResultsTipo.value = [];
      } finally {
        searchingTipo.value = false;
      }
    };

    // Método para seleccionar un tipo de tramite
    const selectTipotramite = (tipoTramite: TipoTramite) => {
      filters.value.tipoSearch = tipoTramite.tipo;
      searchResultsTipo.value = [];
    };
    const hasPermission = (permission: string) => {
      return authStore.hasPermission(permission);
    };
    
    onMounted(() => {
      fetchTipotramite();
      fetchUnidades();
      fetchAreas();
    });
    
    return {
      tipotramites,
      unidades,
      loadingUnidades,
      areas,
      fetchAreas,
      searchResultsTipo,
      searchByTipo,
      selectTipotramite,
      loadingAreas,
      filters,
      loading,
      form,
      errors,
      loadingForm,
      isEditing,
      modalTitle,
      modalVisible,
      pagination,
      handleSearch,
      handlePageChange,
      confirmDelete,
      hasPermission,
      showModal,
      handleSubmit,
      generatePDF,
      generateDetallePDF
    };
  }
};
</script>

<style scoped>
  thead th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
  }
  tbody td {
    margin: 0px;
    padding: 8px !important;
    vertical-align: middle;
  }
  .table-responsive {
    max-height: 600px;
    overflow-y: auto;
  }
  .btn-round {
    border-radius: 50px;
  }
  .badge {
    font-size: 0.85em;
    padding: 0.2em 0.4em;
  }
</style>